import { Box, Button, Dialog, IconButton, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from '../../../../Components/Common Components/CommonComponents'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { localGetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { CurrencySymbol } from '../../../../Utility/Constants'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DateTime } from 'luxon'
import Loader from '../../../../Components/Loader';
import { CheckAccessFunc } from '../../../../Components/CommonFunctions/CommonFunctions'

const STYLES = {
    FONT_SIZE_LOW_2: "0.9rem",
    FONT_SIZE_LOW_3: "0.9rem",
    FONT_WEIGHT: "bold"
};

const BillingPendingList = () => {
    const [isLoader, setIsLoader] = useState(false)
    const [states, setStates] = useState({
        page: 0,
        pageSize: 10,
        pendingListData: [],
        openPopup: false,
        selectedData: null,
        pendingDate: new Date(),
        pendindDatePickerOpen: false,
        setDate: false
    })
    let loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const [userData, setUserData] = useState(loginInfo)
    let history = useHistory()
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API STARTS =======> 

    const checkUserAccess = () => {
        try {
            if (loginInfo?.module_name === 'Laboratory') {
                return CheckAccessFunc("Laboratory", "Hospital Billing", "Pending List", null, "Tab")
            } else if (loginInfo?.module_name === 'Radiology') {
                return CheckAccessFunc("Radiology", "Hospital Billing", "Pending List", null, "Tab")
            } else if (loginInfo?.module_name === 'front_office') {
                return CheckAccessFunc("front_office", "Hospital Billing", "Pending List", null, "Tab")
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }   

    const userAccess = checkUserAccess()

    useEffect(() => {
        getPendingListData()
    }, [])

    const getPendingListData = () => {
        try {
            setIsLoader(true);
            let startDate = new Date(states.pendingDate)
            let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            RestAPIService.getAll(Serviceurls.NEW_BILLING_PENDING_LIST + '?from_date=' + date + '&to_date=' + date)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setStates((prev) => ({ ...prev, pendingListData: response?.data?.data }))
                        setIsLoader(false);
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)                        
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    }

    const deletePendingListData = () => {
        try {
            setIsLoader(true);
            let data = {
                id: states.selectedData?.id
            }
            RestAPIService.delete(Serviceurls.NEW_BILLING_PENDING_LIST, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        getPendingListData()
                        setStates((prev) => ({ ...prev, openPopup: false, selectedData: null }))
                        setIsLoader(false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                        setIsLoader(false);
                    } else {
                        errorMessage(error?.message)
                        setIsLoader(false);
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    }

    // API ENDS =========>

    const gridToolBar = () => {
        var ExportData = []
        states.pendingListData?.length > 0 && states.pendingListData.map((item) =>
            ExportData.push({ 'Patient Name': item.patient_name, 'Date': item.request_date, 'Request NO': item.request_number, 'Reason': item.remarks, 'Requested By': item.requested_by, 'Approver': item.approver_name, 'Status': item.request_status, 'Net Amount': item.net_amount })
        )
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} filename={"Pendinglist"} />
            </Box>

        )
    }

    const renderPatientCard = (item) => {
        try {
            let gender = item?.gender === 'm' ? 'M' : item?.gender === 'f' ? 'F' : 'T'
            let patientName = `${item?.patient_name || item?.first_name} ${item?.patient_age_str || item?.patient_age}/${gender}`
            let uhidMob = `${item.patient_account_number} | ${item?.mobile_number || item?.patient_mobile_number}`
            let profile = item?.photo_url ? item?.photo_url : gender === 'M' ? ImagePaths.Male.default : ImagePaths.Female.default
            let borderColor = item?.patient_type === 'new_patient' ? '#F1584A' : item?.patient_type === 'review_patient' ? '#29B6F6' : '#800080'
            return (
                <Box component={'div'} sx={{ backgroundColor: "white" }}>
                    <Box component={'div'} sx={{ width: "17.3vw" }}>
                        <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                            <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box component={'img'} src={profile} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${borderColor}`} />
                            </Box>
                            <Box component={'div'}>
                                {patientName ? patientName?.length > 25 ?
                                    <Tooltip placement='top' title={patientName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}</Typography> : '-'}
                                {uhidMob ? uhidMob?.length > 18 ?
                                    <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPendingListTable = () => {
        try {
            states.pendingListData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'patient_name', headerName: 'Pateint Details', flex: 0.147,
                    renderCell: (params) => {
                        return (
                            <Box>{renderPatientCard(params?.row)}</Box>
                        )
                    }
                },
                {
                    field: 'request_date', headerName: 'Date And Time', flex: 0.08,
                    renderCell: (params) => {
                        let date = params?.row?.request_date
                        let time = params?.row?.request_time
                        return (
                            <Box component={'div'}>
                                <Typography fontWeight={600} fontSize={'0.9rem'}>{date}</Typography>
                                <Typography color={Colors.grayShade} fontSize={'0.8rem'}>{time}</Typography>
                            </Box>
                        )
                    }
                },
                {
                    field: 'request_number', headerName: 'Request No', flex: 0.09,
                    renderCell: (params) => {
                        let reqNo = params.row?.request_number
                        return (
                            <Box>
                                {reqNo ? reqNo?.length > 15 ?
                                    <Tooltip placement='top' title={reqNo}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{'...' + reqNo?.slice(10)}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{reqNo}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'remarks', headerName: 'Remarks', flex: 0.111,
                    renderCell: (params) => {
                        let reason = params?.row?.remarks
                        return (
                            <Box>
                                {reason ? reason?.length > 15 ?
                                    <Tooltip placement='top' title={reason}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{reason?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{reason}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'requested_by', headerName: 'Requested By', flex: 0.111,
                    renderCell: (params) => {
                        let reqBy = params?.row?.requested_by
                        return (
                            <Box>{reqBy ? reqBy?.length > 15 ?
                                <Tooltip placement='top' title={reqBy}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{reqBy?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{reqBy}</Typography> : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'approver_name', headerName: 'Approver', flex: 0.1,
                    renderCell: (params) => {
                        let appName = params?.row?.approver_name
                        return (
                            <Box>{appName ? appName?.length > 15 ?
                                <Tooltip placement='top' title={appName}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{appName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{appName}</Typography> : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'request_status', headerName: 'Status', flex: 0.111,
                    renderCell: (params) => {
                        let status = params?.row?.request_status
                        return (
                            <Box>{status ? status?.length > 15 ?
                                <Tooltip placement='top' title={status}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{status?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{status}</Typography> : '-'}</Box>
                        )
                    }
                },
                {
                    field: 'net_amount', headerName: `Net Amount (${CurrencySymbol})`, flex: 0.1, align: 'right', headerAlign: 'right',
                    renderCell: (params) => {
                        return (
                            <Box>{params?.row?.net_amount}</Box>
                        )
                    }
                },
                {
                    field: 'action', headerName: 'Action', flex: 0.111,
                    renderCell: (params) => {
                        return (
                            <Box component={'div'} sx={{ visibility: userData?.is_checker ? "hidden" : "visible" }}>
                                <IconButton
                                    disabled={(params?.row?.request_status === 'Cancelled' || params?.row?.request_status === 'Accepted' || params?.row?.request_status === 'Rejected' || !userAccess?.editAccess) ? true : false}
                                    onClick={() => {
                                        if (params?.row?.ip_admission_id) {
                                            history?.push({ pathname: "/IPHome/FinalSettlement", state: { Patient_details: params?.row, approver_id: params?.row?.approver_id, ip_admission_id: params?.row?.ip_admission_id, fromPendingList: true } })
                                        }
                                        else {
                                            let moduleRoutes = {}
                                            moduleRoutes = {
                                                front_office: "/HospitalBilling/HospitalBilling",
                                                Laboratory: "/LabBilling/HospitalBilling",
                                                Radiology: "/RadiologyBilling/HospitalBilling"
                                            };
                                            let pathSet = {
                                                front_office: '/HospitalBilling/PendingList',
                                                Laboratory: '/LabBilling/PendingList',
                                                Radiology: '/RadiologyBilling/PendingList',
                                            }
                                            const routePath = moduleRoutes[userData?.module_name];
                                            const path = pathSet[userData?.module_name];
                                            if (routePath) {
                                                setCachevalue(true, "isForCancelBill")
                                                setCachevalue(true, 'FromOtherScreen')
                                                setCachevalue(path, 'path')
                                                setCachevalue('Modify', 'BillType')
                                                history?.push({
                                                    pathname: routePath, state: {
                                                        patientDetails: params?.row, appointment_id: params?.row?.appointment_id,
                                                        invoiceId: params?.row?.op_bill_id, fromPendingList: true, pending_list_id: params?.row?.id,
                                                        approver_id: params?.row?.approver_id, requested_from: params?.row?.request_from,
                                                        remarks: params?.row?.remarks, approver_name: params?.row?.approver_name
                                                    }
                                                })
                                            }
                                        }
                                    }}
                                ><Box component={'img'} src={(params?.row?.request_status === 'Cancelled' || params?.row?.request_status === 'Accepted' || params?.row?.request_status === 'Rejected' || !userAccess?.editAccess) ? ImagePaths.DisabledEdit.default : ImagePaths.LabEditButton.default} height={'1.5dvw'} width={'1.5dvw'} /></IconButton>
                                <IconButton
                                    disabled={(params?.row?.request_status === 'Cancelled' || params?.row?.request_status === 'Accepted' || params?.row?.request_status === 'Rejected' || !userAccess?.editAccess) ? true : false}
                                    onClick={() => setStates((prev) => ({ ...prev, openPopup: true, selectedData: params?.row }))}
                                ><Box component={'img'} src={(params?.row?.request_status === 'Cancelled' || params?.row?.request_status === 'Accepted' || params?.row?.request_status === 'Rejected' || !userAccess?.editAccess) ? ImagePaths.DisabledDelete.default : ImagePaths.Delete.default} height={'1.5dvw'} width={'1.5dvw'} /></IconButton>
                            </Box>
                        )
                    }
                },
            ]
            return (
                <Box component={'div'} height={'70dvh'} sx={{ backgroundColor: Colors.white }}>
                    <DataGrid
                        rows={states.pendingListData}
                        page={states.page}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        pageSize={states.pageSize}
                        onPageChange={(newPage) => { setStates((prev) => ({ ...prev, page: newPage })) }}
                        onPageSizeChange={(newPageSize) => setStates((prev) => ({ ...prev, pageSize: newPageSize }))}
                        rowsPerPageOptions={[10, 20, 30]}
                        loading={isLoader}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        disableColumnSelector
                        hideFooterSelectedRowCount
                        components={{
                            // Toolbar: CommonGridHeader.CommonToolBar,
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        headerHeight={40}
                    />
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderDeletePopUpScreen = () => {
        try {
            return (
                <Dialog open={states.openPopup} maxWidth='xs' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={500}>{states.selectedData?.appointment_id ? ("Cancel/Convert Transaction") : ("Cancel Transaction")}</Typography>
                            <IconButton onClick={() => setStates((prev) => ({ ...prev, openPopup: false, selectedData: null }))}>
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} textAlign={'center'}>
                            <Typography fontSize={'1.3rem'} fontWeight={600}>Are you sure ?</Typography>
                            <Typography fontSize={'1rem'} fontWeight={500} color={Colors.grayShade}>Do you want to cancel entire transaction or convert this request to bill</Typography>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} m={'1rem 0rem'}>
                            <Button variant='contained' color='error'
                                sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                onClick={() => { 
                                    if(states.selectedData?.ip_admission_id) {
                                        history?.push({ pathname: "/IPHome/FinalSettlement", state: { Patient_details: states.selectedData, ip_admission_id: states.selectedData?.ip_admission_id, fromCancel: true } })
                                    }
                                    else{
                                        deletePendingListData()
                                    }
                                    }}
                            >Cancel Transaction</Button>
                            {states?.selectedData?.appointment_id ? <Button variant='contained'
                                sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                onClick={() => {                                    
                                    let moduleRoutes = {}
                                    moduleRoutes = {
                                        front_office: "/HospitalBilling/HospitalBilling",
                                        Laboratory: "/LabBilling/HospitalBilling",
                                        Radiology: "/RadiologyBilling/HospitalBilling"
                                    };
                                    let pathSet = {
                                        front_office: '/HospitalBilling/PendingList',
                                        Laboratory: '/LabBilling/PendingList',
                                        Radiology: '/RadiologyBilling/PendingList',
                                    }
                                    const routePath = moduleRoutes[userData?.module_name];
                                    const path = pathSet[userData?.module_name];
                                    if (routePath) {
                                        setCachevalue(true, "isForCancelBill")
                                        setCachevalue(true, 'FromOtherScreen')
                                        setCachevalue(path, 'path')
                                        history?.push({
                                            pathname: routePath, state: {
                                                patientDetails: states.selectedData, appointment_id: states.selectedData?.appointment_id,
                                                invoiceId: states.selectedData?.op_bill_id, fromBillConvert: true, requested_from: states.selectedData?.request_from,
                                                pending_list_id: states.selectedData?.id, approver_id: states.selectedData?.approver_id, remarks: states.selectedData?.remarks,
                                                approver_name: states.selectedData?.approver_name
                                            }
                                        })
                                    }                                
                                }}
                            >Convert to Bill</Button> : null }
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        if (states.setDate) {
            getPendingListData()
            setStates((prev) => ({ ...prev, setDate: false }))
        }
    }, [states.setDate]);

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '80dvh' }}>
            <Box component={'div'} p={'0.5rem'}>
                <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mb={'1rem'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            open={states.pendindDatePickerOpen}
                            onOpen={() => { setStates((prev) => ({ ...prev, pendindDatePickerOpen: true })) }}
                            onClose={() => { setStates((prev) => ({ ...prev, pendindDatePickerOpen: false })) }}
                            value={states.pendingDate}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setStates((prev) => {
                                    let data = { ...prev, pendingDate: newDate, setDate: true }
                                    return data
                                })
                            }}
                            maxDate={new Date()}
                            renderInput={(params) => <TextField
                                onKeyDown={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                }} style={{ width: '9.5vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'IP_Date_Search' }} onClick={() => { setStates((prev) => ({ ...prev, pendindDatePickerOpen: true })) }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box>{renderPendingListTable()}</Box>
            </Box>
            {renderDeletePopUpScreen()}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        <Loader loaderOpen={isLoader} />
        </Box>
    )
}

export default BillingPendingList